import Swal, { SweetAlertOptions } from "sweetalert2";

export const SweetAlerts = (Id?: string) => {
  const SweetAlert = (
    type: "success" | "error" | "info",
    message: string,
    props?:  SweetAlertOptions
  ) =>
    Swal.fire({
      icon: type,
      target: Id,
      heightAuto: false,
      showConfirmButton: false,
      text: message,
      width: "330px",
      timer: 2000,
      focusCancel:true,
      ...props,
    });

  const SweetPrompt = (
    type: "question" | "warning",
    message: string,
    props?:  SweetAlertOptions

  ) =>
    Swal.fire({
      icon: type,
      target: Id,
      heightAuto: false,
      text: message,
      width: "330px",
      showCancelButton: true,
      denyButtonText: "Continue",
      confirmButtonText: "Confirm",
      focusCancel:true,


      ...props,
    });

  const SweetAlertOk = (
      type: "success" | "error" | "info",
      message: string,
      props?:  SweetAlertOptions

    ) =>
      Swal.fire({
        icon: type,
        target: Id,
        heightAuto: false,
        showConfirmButton: false,
        text: message,
        width: "330px",
        focusCancel:false,
        allowOutsideClick:false,
        ...props,
      });

      const SweetConfirmPrompt = (
        type: "question" | "warning",
        message: string,
        props?:  SweetAlertOptions
    
      ) =>
        Swal.fire({
          icon: type,
          target: Id,
          heightAuto: false,
          text: message,
          width: "330px",
          showCancelButton: false,
          denyButtonText: "Continue",
          confirmButtonText: "Confirm",
          focusCancel:false,
          allowOutsideClick:false,
    
          ...props,
        });
        const SweetConfirmWithoutBtnPrompt = (
          type: "question" | "warning",
          message: string,
          props?:  SweetAlertOptions
      
        ) =>
          Swal.fire({
            icon: type,
            target: Id,
            heightAuto: false,
            text: message,
            width: "330px",
            showCancelButton: false,
            showConfirmButton:false,
            denyButtonText: "Continue",
            focusCancel:false,
            allowOutsideClick:false,
      
            ...props,
          });

  return { SweetAlert, SweetPrompt,SweetAlertOk,SweetConfirmPrompt,SweetConfirmWithoutBtnPrompt };
};


// Swal.fire({
//   icon: "warning",
//   target: "#EditDepartmentAlert",
//   heightAuto: false,
//   width: "300px",
//   text: "Are you sure you want to cancel Department creation?",
//   confirmButtonText: "Confirm",
//   denyButtonText: "Continue",
//   showCancelButton: true,
// })
